"use strict";

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

exports.__esModule = true;

var ramda_1 = require("ramda"); // import or from 'ramda/es/or'
// import and from 'ramda/es/and'
// import filter from 'ramda/es/filter'
// import complement from 'ramda/es/complement'
// import isNil from 'ramda/es/isNil'
// import pipe from 'ramda/es/pipe'
// import propEq from 'ramda/es/propEq'
// import find from 'ramda/es/find'
// import curry from 'ramda/es/curry'
// import findIndex from 'ramda/es/findIndex'
// import update from 'ramda/es/update'
// import remove from 'ramda/es/remove'
// import replace from 'ramda/es/replace'


exports.OR = function (pred1, pred2) {
  return function (value) {
    return ramda_1.or(pred1(value), pred2(value));
  };
};

exports.AND = function (pred1, pred2) {
  return function (value) {
    return ramda_1.and(pred1(value), pred2(value));
  };
};

exports.exclude = ramda_1.pipe(ramda_1.complement, ramda_1.filter);
exports.isNotNil = ramda_1.complement(ramda_1.isNil);

exports.highlight = function (word, HIGHLIGHT_DELIMETER) {
  if (HIGHLIGHT_DELIMETER === void 0) {
    HIGHLIGHT_DELIMETER = ' ';
  }

  return function (str) {
    if (!word) {
      return str;
    }

    var regStr = word.split(HIGHLIGHT_DELIMETER).filter(function (word) {
      return word !== '';
    }).map(exports.escapeRegExp).join('|');
    var reg = new RegExp("(" + regStr + ")", 'gi');
    return str.replace(reg, '<mark>$1</mark>');
  };
};

exports.removeTag = function (html) {
  if (html === undefined) {
    return '';
  }

  return html.replace(/(<([^>]+)>)/gi, '');
};

exports.peek = function () {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return function (value) {
    // console.log('peek called')
    console.log.apply(console, __spreadArrays(args, [value])); // eslint-disable-line

    return value;
  };
};

exports.go = function () {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  } // @ts-ignore


  return ramda_1.pipe.apply(void 0, args.slice(1))(args[0]);
};

exports.constant = function (value) {
  return function () {
    return value;
  };
};

exports.noop = function () {};

exports.indexMap = function () {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  if (args.length === 1) {
    return function (list) {
      Array.prototype.map.call(list, args[0]);
    };
  }

  return Array.prototype.map.call(args[1], args[0]);
};

exports.idEqual = ramda_1.propEq('_id');
exports.findById = ramda_1.pipe(exports.idEqual, ramda_1.find);
exports.updateBy = ramda_1.curry(function (pred, tobe) {
  return function (list) {
    var index = ramda_1.findIndex(pred)(list);
    return ramda_1.update(index, tobe)(list);
  };
});

exports.removeBy = function (pred) {
  return function (list) {
    var index = ramda_1.findIndex(pred)(list);
    return ramda_1.remove(index, 1)(list);
  };
};

exports.updateById = ramda_1.curry(function (id, tobe, list) {
  return exports.updateBy(exports.idEqual(id))(tobe)(list);
});
exports.removeById = ramda_1.curry(function (id, list) {
  return exports.removeBy(exports.idEqual(id))(list);
});
/*
 * 패러미터 문자열 중 아래와 같이 매칭되는 문자열을 변환
 * [제목](링크) => <a href="링크">제목</a>
 * */

exports.addLink = ramda_1.replace(/\[(.+)\]\(([^()]+)\)/g)('<a href="$2">$1</a>');

exports.flatLog = function () {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var serialized = args.map(function (arg) {
    if (typeof arg === 'object') {
      return JSON.stringify(arg, null, 2);
    } else if (typeof arg === 'function') {
      return arg.toString();
    }

    return arg;
  }); // eslint-disable-next-line

  console.log.apply(console, serialized);
};

exports.forceFileDownload = function (blob, name) {
  var url = window.URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  link.click();
};

exports.download = function (_a) {
  var uri = _a.uri,
      name = _a.name;
  return __awaiter(void 0, void 0, void 0, function () {
    var response, blob;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4
          /*yield*/
          , fetch(uri)];

        case 1:
          response = _b.sent();
          return [4
          /*yield*/
          , response.blob()];

        case 2:
          blob = _b.sent();
          exports.forceFileDownload(blob, name);
          return [2
          /*return*/
          ];
      }
    });
  });
};

exports.getHostname = function (url) {
  var start = url.indexOf('://') + 3;
  var end = url.indexOf('/', start);
  return url.slice(start, end);
};

exports.getProtocol = function (url) {
  var end = url.indexOf('://') + 3;
  return url.slice(0, end);
};

exports.assignQueryParams = function (url) {
  return function (paramObj) {
    exports.setQueryParams(Object.assign([], exports.getQueryParams(url), paramObj));
  };
};

exports.appendQueryParams = function (paramObj) {
  return exports.assignQueryParams(location.href)(paramObj);
};

exports.copyToClipboard = function (val) {
  var t = document.createElement('textarea');
  document.body.appendChild(t);
  t.value = val;
  t.select();
  document.execCommand('copy');
  document.body.removeChild(t);
};

exports.blinkDomElement = function (dom) {
  var BORDER_STYLE = '1px solid red';
  var INTERVAL = 500;
  var TIMEOUT = 3000;

  if (!dom) {
    console.warn('[blinkDomElement] Not found blink dom');
    return;
  }

  dom.style.border = BORDER_STYLE;
  var interval = setInterval(function () {
    // console.log('3초간 깜빡임', dom.style.border)
    dom.style.border = dom.style.border === BORDER_STYLE ? '' : BORDER_STYLE;
  }, INTERVAL);
  setTimeout(function () {
    // console.log('깜빡임 끝')
    clearInterval(interval);
    dom.style.border = '';
  }, TIMEOUT);
};

exports.timer = function (timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
};

exports.esModule = function (_module) {
  return _module["default"] || _module;
};

function removeExt(filename) {
  return filename.replace(/\.(\w*)$/, '');
}

exports.removeExt = removeExt;

exports.getFileName = function (path, ext) {
  if (ext === void 0) {
    ext = false;
  }

  var getFileNameRegex = /[^\\/]+\.[^\\/]+$/;
  var _a = (path.match(getFileNameRegex) || [])[0],
      file = _a === void 0 ? null : _a;
  var name = file || path;
  return ext ? name : removeExt(name);
};

exports.nl2br = function (str) {
  if (!str) {
    return '';
  }

  return str.replace(/\r\n|\n/g, '<br />');
};

exports.createRandomString = function (length) {
  if (length === void 0) {
    length = 5;
  }

  var text = ''; // noinspection SpellCheckingInspection

  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  Array.from(Array(length)).forEach(function () {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  });
  return text;
};

exports.getQueryParams = function (url) {
  var params = {};
  var idx = url.indexOf('?') + 1;
  var fromIdx = url.slice(idx); // @ts-ignore

  fromIdx.replace(/([^(?|#)=&]+)(=([^&]*))?/g, function ($0, $1, $2, $3) {
    params[$1] = $3;
  });
  return params;
};

exports.setQueryParams = function (paramObj) {
  var params = Object.entries(paramObj).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    var valueStr = value;

    if (Array.isArray(value)) {
      valueStr = value.join(',');
    }

    return key + '=' + valueStr;
  }).join('&'); // console.log(params)

  window.history.pushState({}, '', '?' + params);
};

exports.delay = function (fn, ms) {
  return new Promise(function (resolve) {
    var timeout = setTimeout(function () {
      fn();
      resolve(timeout);
    }, ms);
  });
};

exports.onlyNumber = function (event) {
  if (event.keyCode < 48 || event.keyCode > 57) {
    event.returnValue = false;
  }
};

exports.numberWithCommas = function (num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

exports.enableUrl = function (str) {
  if (!str) {
    return '';
  }

  var isUrl = /((?:http|https?|ftps?|sftp):\/\/(?:[a-z0-9-]+\.)+[a-z0-9]{2,4}\S*)/gi;

  if (isUrl.test(str)) {
    return str.replace(isUrl, '<a href="$1">$1</a>');
  }

  var wwwStart = /(www\.(?:[a-z0-9-]+\.)+[a-z0-9]{2,4}\S*)/gi;

  if (wwwStart.test(str)) {
    return str.replace(wwwStart, '<a href="http://$1">$1</a>');
  }

  return str;
};

exports.loadJs = function (src) {
  return new Promise(function (resolve) {
    var headTag = document.getElementsByTagName('head')[0];
    var newScript = document.createElement('script');
    newScript.type = 'text/javascript';

    newScript.onload = function () {
      resolve();
    };

    newScript.src = src;
    headTag.appendChild(newScript);
  });
};

exports.sortKeys = function (obj, pred) {
  var keys = Object.keys(obj);
  var sorted = {};
  keys.sort(pred).forEach(function (key) {
    sorted[key] = obj[key];
  });
  return sorted;
};

exports.onlyOneInvoke = function (fn) {
  var invoked = false;
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (invoked) {
      return;
    }

    invoked = true;
    return fn.apply(void 0, args);
  };
};

exports.escapeRegExp = function (text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&');
};